<template>
  <!-- <div class="center"> -->
    <v-card style="background-color: #e8eaf6" class="vcard" hover>
      <center><img class="img" src="../assets/Logo/test.png" alt="System Logo" /></center>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card-text>
          <v-text-field 
            clearable
            rounded
            color="#1A237E"
            v-model="username"
            :label="$t('Login.email')"
            outlined
            dense
            prepend-inner-icon="mdi-account"
            :rules="emailRules"
            required
            tabindex="1"
          > 
          </v-text-field>
          <v-text-field 
            clearable
            rounded
            color="#1A237E"
            v-model="password"
            :label="$t('Login.password')"
            prepend-inner-icon="mdi-lock"
            :append-icon="show == true ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show == true ? 'text' : 'password'"
            @click:append="show = !show"
            outlined
            dense
            tabindex="2"
            @keypress.enter="!valid || !username || !password ? '' : login()"
          > 
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!valid || !username || !password" @click="login()"  outlined :loading="loading" block color="#0D47A1">
            {{$t('Login.login')}}
          </v-btn>
        </v-card-actions>
        <div class="text-left mt-3">
          <center>
            <span>{{ $t("Login.language") }}: </span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" small text outlined v-on="on" color="#FFFAFA">
                  <h5 style="color: #0d47a1;">{{ `${$i18n.locale}` }}</h5></v-btn
                >
              </template>
              <v-list>
                <v-list-item @click="translate('ja')">
                  <v-list-item-title>
                    <div class="d-flex align-center">
                      <img src="../../public/img/flags/japan_64.png" style="width: 34px;">
                      <div class="ml-2">
                        <span class="d-block text-center">JA</span>
                      </div>
                    </div>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="translate('en')">
                  <v-list-item-title>
                    <div class="d-flex align-center">
                      <img src="../../public/img/flags/us_64.png" style="width: 34px;">
                      <div class="ml-2">
                        <span class="d-block text-center">EN</span>
                      </div>
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </center>
        </div>
      </v-form>
    </v-card>
  <!-- </div> -->
</template>
<script>
import DataTransform from '../assets/class/DataTransform.js'
import axios from "axios";
import Swal from "sweetalert2";
import md5 from 'md5'
export default {
  data() {
    return {
      dataTransform: new DataTransform(),
      lang: "",
      userGuide: false,
      show: "",
      holder: {},
      confirmPass: "",
      username: "",
      password: "",
      loading: false,
      valid: true,
      emailRules: [
        v => !v || v.trim() === '' || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || '無効なメール。'
      ]
    };
  },
  methods: {
    async login() {
      this.loading = true
      let userData = {
          email: this.username,
          password: this.password
      }
      const { data } = await axios.post(`${this.cognitoApi}getCognitoUser`, userData);
      if (data && !data.message) {
          this.LoginAlert('success');
          this.$store.commit("STORE_USERINFO", data)
          this.$router.push("/").then(() => {
            this.$nextTick(() => {
              location.reload();
            });
          });
      } else {
        const { data } = await axios.post(this.ichijoLegacyApi, userData, this.ichijoLegacyApiKey);
        const response = data
        if (response && !response.message) {
          await axios.post(`${this.cognitoApi}insertUserToCognito`, response);
          const { data } = await axios.post(`${this.cognitoApi}getCognitoUser`, response);
          if (data && !data.message) {
              this.LoginAlert('success');
              this.$store.commit("STORE_USERINFO", data)
              this.$router.push("/").then(() => {
                this.$nextTick(() => {
                  location.reload();
                });
              });
          }
        }else{
          this.AccessDenied()
        }
      }
      this.loading = false
    },
    openUserGuideDialog() {
      this.userGuide = true;
    },
    closeUserGuideDialog() {
      this.userGuide = false;
    },
    translate(val) {
      this.lang = val;
      this.$i18n.locale = val;
    },
    comparePasswords(userPassword, Password) {
      const hashedUserPassword = md5(userPassword); // Hash the password provided by the user
      return hashedUserPassword === Password;
    },
    formatEmpCode(empCode) {
      if(empCode){
        if (empCode.length < 5) {
          const zerosToAdd = 5 - empCode.length;
          const formattedEmpCode = '0'.repeat(zerosToAdd) + empCode;
          return formattedEmpCode;
        } else {
          return empCode;
        }
      }else{
        return empCode
      }
    },
    insertNewUser(data){
      axios.post(`${this.aws}insertPlannerCredential`, data).then((res) => {
        if(res.data){
          this.loading = false;
        }
      }).catch((error) => {
        console.error('Error inserting user:', error);
        this.loading = false;
      });
    },
    getUserCategory(userCategory) {
      const normalizedCategory = userCategory.toLowerCase();
      if (normalizedCategory === 'admin') {
        return 'admin';
      } else if (normalizedCategory === 'gc admin') {
        return 'GC Admin';
      } else {
        return 'admin';
      }
    },
    LoginAlert() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: `${this.$i18n.locale == "ja" ? "正常にサインインしました " : "Signed in successfully"}`,
      });
    },
    NoUserMessage() {
      this.loading = false;
        Swal.fire({
          position: "center",
          icon: "error",
          title: `${
            this.$i18n.locale == "ja"
            ? "パスワードが正しくありません。"
            : "Incorrect password."
          }`,
          showConfirmButton: false,
          timer: 2000,
      });
    },
    AccessDenied(){
      this.loading = false;
      Swal.fire({
          position: "center",
          icon: "warning",
          title: `アクセス拒否`,
          showConfirmButton: false,
          timer: 1500,
      });
    },
    ErrorMessage(message) {
      this.loading = false;
        Swal.fire({
          position: "center",
          icon: "error",
          title: `${message}`,
          showConfirmButton: false,
          timer: 2000,
      });
    },
    async login2() {
      try {
        const params = new URLSearchParams(window.location.search);
        this.username = params.get('index');
        this.password = params.get('id');
        if(this.username && this.password){
          const res = await axios.get(`${this.gcAWS}users/getIchijoUsers/${this.username}/${this.password}`);
          if(res.data.length > 0){
            axios.get(`${this.DSS_api}getAllUsers`).then(res2 => {
              const { data } = res2;
              const userInfo = data.find(x => res.data[0].user_category === 'ICHIJO' || res.data[0].user_category === 'GC' ? res.data[0].email === x.MailAddress : res.data[0].mail_address === x.MailAddress);
              let obj = {
                Emp_code: userInfo ? this.formatEmpCode(userInfo.UserId) : this.formatEmpCode(res.data[0].UserId),
                Mail_Address: userInfo ? userInfo.MailAddress : res.data[0].MailAddress,
                Name: userInfo ? userInfo.Name : res.data[0].Name,
                Password: md5(this.password),
                User_Category: userInfo ? userInfo.accType ? userInfo.accType : userInfo.isGCUser ? 'GC User' : null : res.data[0].company_group + ' User',
                pageReloaded: true
              }
              this.insertNewUser(obj)
              if(this.password == 'ichijo'){
                obj.Default = 'true'
              }
              this.$store.commit("STORE_USERINFO", this.dataTransform.toEncrypt(obj));
              this.$router.push("/");
            })
          }
        }
      } catch (error) {
        this.ErrorMessage(error.message)
      }
    },
    async ConvertToToken(data){
      let resx = await axios.post(`${this.aws}ConvertoToken`, data)
      return resx
    }
  },
  mounted() {
    // this.login2()
  },
};
</script>

<style>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
}

.vcard {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 400px;
  padding: 1%;
  margin: 10%;
}

.img {
  display: block;
  height: auto;
  max-height: 25vh;
  max-width: 100%;
  margin: 0 auto;
}
@media (min-width: 1200px) {
  .vcard {
    margin: 20px;
  }
}
</style>
